import { amountAs, makeAmountWith } from '@miq/utils';
import { Units } from 'uom-units';

export const sortUsages = (record: Record<string, any>) => {
  const byPrimaryFlag = (a, b) => Number(b.primary_usage_f) - Number(a.primary_usage_f);
  const byStatistical = (a, b) => Number(b.statistical_f) - Number(a.statistical_f);

  const isValidNRA = (value): boolean => {
    return value !== undefined && value !== '' && value !== '-';
  };
  const getNetRentableArea = (usage): number => {
    if (isValidNRA(usage.net_rentable_area)) {
      return Number(usage.net_rentable_area);
    }
    return -1;
  };
  const byLargestNRA = (a, b): number => {
    const nraA = getNetRentableArea(a);
    const nraB = getNetRentableArea(b);
    if (nraA !== -1 && nraB !== -1) {
      const minObj = makeAmountWith({
        value: b.net_rentable_area,
        uom: b.net_rentable_area_uom_desc,
        defaultUnit: Units.SquareFeet,
      });
      const minAmount = amountAs(Units.SquareFeet, minObj);

      const maxObj = makeAmountWith({
        value: a.net_rentable_area,
        uom: a.net_rentable_area_uom_desc,
        defaultUnit: Units.SquareFeet,
      });
      const maxAmount = amountAs(Units.SquareFeet, maxObj);
      return minAmount - maxAmount;
    }
    return nraB - nraA;
  };
  return record?.usages?.sort((a, b) => byPrimaryFlag(a, b) || byStatistical(a, b) || byLargestNRA(a, b));
};
/**
 * Mutates the sorting state of usages for each record in the list
 **/
export const sortUsagesInRecordList = (records: Record<string, any>[]) => {
  records.forEach(sortUsages);
};
